import { render, staticRenderFns } from "./invite-professional-company.vue?vue&type=template&id=0ab15c92&scoped=true&"
import script from "./invite-professional-company.vue?vue&type=script&lang=js&"
export * from "./invite-professional-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab15c92",
  null
  
)

export default component.exports